// src/components/dashboards/dashboardSurface.ts
// ---------------------------------------------------------------------------
// Is this component rendering on the dashboard's dark surface?
//
// This replaces the A/B variant switch (`dashboardVariant.ts`) that carried the
// five design proposals. Bubbles won, so there is nothing left to switch
// between and the question collapses to one predicate: the dashboard is dark,
// everything else is not.
//
// It stays a predicate rather than becoming a constant because the charts are
// NOT dashboard-only: `useChartTheme` is also used by the superadmin panel's
// landing-analytics and monitoring charts, which render on a different surface
// and must keep their light ink. Hardcoding `dark = true` in that hook would
// silently re-ink those pages.
//
// It also fixes an inconsistency the variant had: the choice lived in
// localStorage, so a session that had looked at a dark proposal carried it onto
// /superadmin and re-inked those charts too. Keyed on the route, the answer is
// the same every time.
// ---------------------------------------------------------------------------

// ⚠️ Consumers of this (and of useDashboardInk / useChartTheme, which both go
// through it) need a Router in context. In the app they always have one; a
// unit test rendering such a component in isolation must wrap it in
// <MemoryRouter>, or useLocation throws.
import { useLocation } from "react-router-dom";

export const DASHBOARD_PATH = "/dashboard";

export function useIsDashboardSurface(): boolean {
  const location = useLocation();
  return location.pathname === DASHBOARD_PATH;
}
